export default "/images/Pro-12b.png?6a1e27c0b7d7382e134b9d333fbde2b2";